export const isBrowser = () => typeof window !== 'undefined';

export const isInsideIframe = (): boolean => {
  if (!isBrowser()) return false;
  return window.self !== window.top;
};
